import { Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  /** The zone in which answering the action needs `workflows.confirm` (nap-backend#1951). */
  readonly zone: string | null | undefined;
  /** Whether that is not the message's zone; see {@link confirmZoneDiffers}. */
  readonly differs: boolean;
}

/**
 * The zone of a workflow action that still waits for input: where answering it needs `workflows.confirm`, flagged when
 * it is not the message's zone, as for an action added from another zone's queue. Nothing without a zone, as from a
 * backend before nap-backend#1951 or for an action whose message has no zone.
 */
export const ConfirmZone = ({ zone, differs }: Props) => {
  const { t } = useTranslation();
  if (typeof zone !== 'string' || zone === '') return null;
  return (
    <p className="small text-muted mb-2">
      <strong>{t('workflows.confirm_zone')}: </strong>
      {zone}
      {differs && (
        <Badge bg="warning" text="dark" className="ms-2">
          {t('workflows.confirm_zone_differs')}
        </Badge>
      )}
    </p>
  );
};
